module.exports = __webpack_public_path__ + "img/favorites.ec461d1b.svg";